export default __webpack_public_path__ + "static/media/expl-dissect_03_EN.97a559ca.png";